module.exports = __webpack_public_path__ + "img/no-orders-icon.0f072381.png";